module.exports = __webpack_public_path__ + "static/media/yardnapha.cf2b1a36.png";